import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import lockImage from './../../images/lock.png'
import Select from 'react-select';
import { toEnglish, toPersian } from 'persian';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import './LicenseGenerator.css'
import toast from 'react-hot-toast';
import { getLicense, updateLicense } from '../../service/customerService';
import moment from 'moment-jalaali';
import CopyToClipboard from 'react-copy-to-clipboard';

const LicenseGeneratorModal = ({ showModal, handleClose, customer, admin, setNewLicense }) => {

    const [customerCode, setCustomerCode] = useState('');
    const [license, setLicense] = useState();
    const [licensePeriod, setLicensePeriod] = useState(); // or onlineShop
    const licensePeriods = [
        { label: toPersian('1 ماه'), value: '01' },
        { label: toPersian('2 ماه'), value: '02' },
        { label: toPersian('3 ماه'), value: '03' },
        { label: toPersian('4 ماه'), value: '04' },
        { label: toPersian('5 ماه'), value: '05' },
        { label: toPersian('6 ماه'), value: '06' },
        { label: toPersian('7 ماه'), value: '07' },
        { label: toPersian('8 ماه'), value: '08' },
        { label: toPersian('9 ماه'), value: '09' },
        { label: toPersian('10 ماه'), value: '10' },
        { label: toPersian('11 ماه'), value: '11' },
        { label: 'یک ساله', value: '12' },
    ]
    const [isLoading, setIsLoading] = useState(false);
    const digits = persian_fa.digits;
    const [licenseStartDate, setLicenseStartDate] = useState(false);

    useEffect(() => {
        if (!showModal && (license || licensePeriod || licenseStartDate || customerCode)) {
            setLicense('');
            setLicensePeriod();
            setLicenseStartDate(false);
            setCustomerCode('');
        }
        else if (showModal) {
            setCustomerCode(customer.subscriptionNumber || '')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showModal])

    const getLicenseHandler = async (event) => {
        event.preventDefault();
        try {
            if (!customerCode) {
                return toast.error('کد اشتراک مشتری را وارد کنید')
            }
            else if (customerCode && customerCode.length !== 10) {
                return toast.error('فرمت کد اشتراک صحیح نیست')
            }
            else if (!licenseStartDate) {
                return toast.error('زمان شروع لایسنس را مشخص کنید')
            }
            else if (!licensePeriod) {
                return toast.error('مدت لایسنس را انتخاب کنید')
            }
            const info = {
                adminName: admin,
                startTimeStamp: moment(Number(licenseStartDate)).utc(false).add('3.5', 'hours').startOf('day').subtract('3.5', 'hours').unix() * 1000,
                month: licensePeriod.value,
                customerCode: customerCode
            }
            setIsLoading(true);
            const { status, data } = await getLicense(info);
            if (status === 201) {
                setLicense(data.info);
            }

        } catch (err) {
            toast.error('خطایی رخ داده است')
        }
        setIsLoading(false)
    };

    const storeLicenseHandler = async (event) => {
        event.preventDefault();
        try {
            const info = {
                license: license.licenseCode,
                companyName: customer.companyName,
                customerCode: customerCode
            }
            setIsLoading(true);
            const { status } = await updateLicense(info);
            if (status === 201) {
                const thisMonth = moment(license.expire, 'jYYYY/jMM/jDD').jMonth();
                const expireTimeStamp = thisMonth < 6 ? moment(license.expire, 'jYYYY/jMM/jDD').utc(false).add('1', 'hour').unix() * 1000 :  moment(license.expire, 'jYYYY/jMM/jDD').utc(false).unix() * 1000;
                setNewLicense(customer.companyName, license.licenseCode, customerCode, expireTimeStamp);
                toast.success('عملیات با موفقیت انجام شد')
                handleClose();
            }

        } catch (err) {
            if (err.response && err.response.status === 404) {
                toast.error('کاربر یافت نشد')

            }
            else {
                toast.error('خطایی رخ داده است')
            }
        }
        setIsLoading(false)
    };

    return (
        <Modal
            size="sm"
            show={showModal}
            onHide={handleClose}
            aria-labelledby="example-modal-sizes-title-sm"
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title id="license-modal-sizes-title-sm" className='rtl d-flex align-items-center ml-auto'>
                    <img src={lockImage} alt="" style={{ width: "40px", marginLeft: '10px' }} />
                    ایجاد لایسنس جدید
                </Modal.Title>
            </Modal.Header>
            {
                customer &&
                <Modal.Body>
                    <div className='d-flex justify-content-between rtl' style={{ fontSize: '.9rem' }}>
                        <div className=''>
                            نام کمپانی:
                        </div>
                        <div className=''>
                            <div>{customer.companyName}</div>
                        </div>
                    </div>
                    <div className='d-flex justify-content-between  align-items-center rtl my-2' style={{ fontSize: '.9rem' }}>
                        <div className=''>
                            شماره اشتراک:
                        </div>
                        <div className='d-flex justify-content-between'>
                            <div>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="cid"
                                    style={{ textAlign: 'center', direction: "ltr", width: '140px', height: '38px', fontSize: '.8rem' }}
                                    placeholder='کد اشتراک '
                                    value={customerCode}
                                    onChange={(e) => setCustomerCode(toEnglish(toPersian(e.target.value)))}
                                />
                            </div>
                        </div>
                    </div>
                    <section className="d-flex justify-content-center align-items-center rtl" style={{ fontSize: '.8rem' }}>
                        <div className="create-person-calendar">
                            <DatePicker
                                format="YYYY/MM/DD"
                                placeholder='زمان شروع'
                                calendar={persian}
                                locale={persian_fa}
                                calendarPosition="top-center"
                                value={licenseStartDate}
                                id="licenseStartDate_input"
                                onChange={(date, { input, isTyping }) => {
                                    try {
                                        if (!isTyping) return setLicenseStartDate(date); // user selects the date from the calendar and no needs for validation.

                                        let value = input.value;
                                        for (let digit of digits) {
                                            value = value.replace(
                                                new RegExp(digit, "g"),
                                                digits.indexOf(digit)
                                            );
                                        }

                                        const strings = value.split("/");
                                        const numbers = strings.map(Number);
                                        const [year, month, day] = numbers;
                                        if (input.value && numbers.some((number) => isNaN(number))) {
                                            return false; //in case user enter something other than digits
                                        }
                                        if (String(year).length > 4) return false; //month < 0 in case user want to type 01
                                        if (month > 12 || month < 0) return false; //month < 0 in case user want to type 01
                                        if (day < 0 || (date && day > date.day)) return false;
                                        if (strings.some((val) => val.startsWith("00"))) return false;

                                        setLicenseStartDate(Number(date));
                                    } catch (err) {
                                        return false
                                    }
                                }}
                            />
                        </div>
                        <Select
                            placeholder="مدت لایسنس"
                            value={licensePeriod}
                            onChange={selectedOption => setLicensePeriod(selectedOption)}
                            options={licensePeriods}
                            isClearable={false}
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    marginTop: "0px",
                                    marginRight: '5px',
                                    width: "140px",
                                    boxShadow: state.isFocused
                                        ? "0 0 0 0.2rem rgba(0,123,255,.25)"
                                        : "none",
                                    borderColor: state.isFocused
                                        ? "#80bdff"
                                        : baseStyles.borderColor,
                                }),
                                menuList: (baseStyles, state) => ({
                                    ...baseStyles,
                                    maxHeight: "200px",
                                    textAlign: "right",
                                }),
                            }}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: "#ddd",
                                    primary: "rgb(40, 167, 69)",
                                },
                            })}
                            isRtl={true}
                            noOptionsMessage={() => "موردی وجود ندارد"}
                        />
                    </section>
                    <Button variant="outline-primary" className='w-100 my-2' size='sm' onClick={getLicenseHandler} disabled={isLoading}>
                        دریافت کد
                        <i className='fa fa-key ml-2'></i>
                    </Button>
                    <div className='mt-5'>
                        {
                            license &&
                            <div className='alert alert-success px-2' style={{ fontSize: '.75rem' }}>
                                <div className='d-flex ltr align-items-center justify-content-between mt-2'>
                                    <div style={{ fontSize: '.6rem' }}>{String(license.licenseCode)}</div>
                                    <div>
                                        <CopyToClipboard text={String(license.licenseCode)} onCopy={() => toast.success('لایسنس در کلیپ بورد کپی شد')}>
                                            <button className='btn btn-sm btn-success d-flex align-items-center me-3 p-0 justify-content-center align-self-center'
                                                style={{ width: '25px', height: '25px' }}
                                            >
                                                <i className='fa fa-clipboard fs-6 '></i>

                                            </button>
                                        </CopyToClipboard>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-between align-items-center rtl mt-2'>
                                    <div>مدت اعتبار : </div>
                                    <div>{toPersian(license.periodTime)} ماه</div>
                                </div>
                                <div className='d-flex justify-content-between align-items-center mt-2 rtl'>
                                    <div>تاریخ انقضا : </div>
                                    <div>{toPersian(license.expire)}</div>
                                </div>
                            </div>

                        }
                    </div>
                </Modal.Body>
            }
            <Modal.Footer>
                <Button variant="secondary w-25" onClick={handleClose} disabled={isLoading}>
                    لغو
                </Button>
                <Button variant="success w-25" disabled={!license || isLoading} onClick={storeLicenseHandler}>
                    ذخیره
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default LicenseGeneratorModal;